<template>
    <div class="inline">
        <span
            v-on:click="open()"
            type="button"
            class="inline-block text-sm cursor-pointer orange-link"
        >
            (cancel)
        </span>

        <!-- MODAL CONTAINER WITH BACKDROP -->
        <div v-show="isOpening()">
            <!-- MODAL -->
            <div
                v-bind:class="{
                    'opacity-0': isOpening(),
                    'opacity-100': isOpen()
                }"
                class="fixed z-50 top-0 left-0 w-full h-full outline-none transition-opacity duration-200 linear"
                tabindex="-1"
                role="dialog"
            >
                <!-- MODAL DIALOG -->
                <div
                    v-bind:class="{ 'mt-4': isOpening(), 'mt-8': isOpen() }"
                    class="relative w-auto pointer-events-none max-w-lg mt-8 mx-auto transition-all duration-200 ease-out"
                >
                    <!-- MODAL CONTAINER -->
                    <div
                        class="relative flex w-full flex-col w-full pointer-events-auto bg-white border border-gray-300 rounded-lg shadow-xl"
                    >
                        <div
                            class="flex items-start justify-between px-2 pt-2 rounded-t"
                        >
                            <div class="w-auto"></div>
                            <button
                                type="button"
                                class="close relative w-4"
                                v-on:click="close()"
                            >
                                &times;
                            </button>
                        </div>
                        <div class="relative p-4">
                            <h3 class="text-3xl font-bold mb-5 leading-9">
                                Are you sure that you want to cancel?
                            </h3>
                            <p class="mb-5 text-red-500 font-bold">
                                WARNING: Once you cancel, you will no longer be
                                able to access course audio or any instructional
                                materials.
                            </p>
                        </div>
                        <div class="flex items-center justify-end p-4">

                            <a class="text-orange-600 text-sm inline-block font-normal text-center px-3 py-2" :href="link" >Yes, continue to cancellation</a> 
                             
                                
                            <button
                                v-on:click="close()"
                                type="button"
                                class="inline-block font-normal text-center px-3 py-2 leading-normal text-base rounded cursor-pointer text-white bg-gray-600 mr-2"
                            >
                                Close
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <!-- BACKDROP -->
            <div
                v-bind:class="{ 'opacity-25': isOpen() }"
                class="z-40 fixed top-0 left-0 bottom-0 right-0 bg-black opacity-0 transition-opacity duration-200 linear"
            ></div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return { state: "CLOSED" };
    }, // [CLOSED, TRANSITION, OPEN] },
    props: ['link'],
    methods: {
        open() {
            this.state = "TRANSITION";
            setTimeout(() => {
                this.state = "OPEN";
            }, 50);
        },
        close() {
            this.state = "TRANSITION";
            setTimeout(() => {
                this.state = "CLOSED";
            }, 300);
        },
        isOpen() {
            return this.state === "OPEN";
        },
        isOpening() {
            return this.state !== "CLOSED";
        }
    }
};
</script>

<style></style>
